import { isArray, isObject } from "./type"

export function clone(o, ...args) {
    // 浅克隆
    if (isArray(o)) {
        return [].concat(o, ...args)
    }
    if (isObject(o)) {
        return Object.assign({}, o, ...args)
    }
    return o
}

export function deepClone(o) {
    // 深克隆
    if (typeof o !== "object") {
        return o
    }
    const _o = isArray(o) ? [] : {}
    for (let prop in o) {
        if (o.hasOwnProperty(prop)) {
            if (isArray(o[prop]) || isObject(o[prop])) {
                _o[prop] = deepClone(o[prop])
            } else {
                _o[prop] = o[prop]
            }
        }
    }
    return _o
}
